import template from './project-access-list.pug';

export const ProjectAccessListComponent = {
  template,
  bindings: {
    projectId: '<?',
    userId: '<?',
  },
  controller: class ProjectAccessListComponent {
    constructor($async, $log, Project, AlertBox, User) {
      'ngInject';
      this.Project = Project;
      this.User = User;
      this.AlertBox = AlertBox;
      this.$log = $log;
      this.isAllEnabled = false;
      this.enabledRecords = [];
      this.records = [];

      this.getUsers = $async(this.getUsers.bind(this));
      this.getProjects = $async(this.getProjects.bind(this));
      this.getEnabledPermissions = $async(this.getEnabledPermissions.bind(this));
      this.togglePermission = $async(this.togglePermission.bind(this));
    }

    $onInit() {
      this.getEnabledPermissions();

      if (this.projectId) {
        this.getUsers();
      } else if (this.userId) {
        this.getProjects();
      }
    }

    async getEnabledPermissions() {
      try {
        const params = this.projectId ? { project_id: this.projectId } : { user_id: this.userId };
        const resp = await this.Project.enabledPermissions(params);
        this.enabledRecords = resp || [];
      } catch (e) {
        this.$log.error(e);
      } finally {
        this.checkIsAllEnabled();
      }
    }

    async getUsers() {
      try {
        const resp = await this.User.getList({ fields: { user: ['id', 'name', 'project_count'] } });
        this.records = resp || [];
      } catch (e) {
        this.$log.error(e);
      } finally {
        this.checkIsAllEnabled();
      }
    }

    async getProjects() {
      try {
        const resp = await this.Project.getGroups(true);
        this.records = resp || [];
      } catch (e) {
        this.$log.error(e);
      }
    }

    checkIsAllEnabled() {
      this.isAllEnabled = (this.enabledRecords.length == this.records.length);
    }

    async toggleAllPermissions(enabled) {
      try {
        let allowedToBeChanged = [];
        if (enabled) {
          this.enabledRecords = this.records.map(record => record.id);
          allowedToBeChanged = [...this.enabledRecords];
        } else {
          this.records.forEach(item => {
            if (item.project_count <= 1) {
              allowedToBeChanged.push(item.id);
            }
          });
          this.enabledRecords = this.enabledRecords.filter(item => allowedToBeChanged.includes(item));
        }
        const params = { project_id: parseInt(this.projectId), user_ids: allowedToBeChanged };

        await this.Project.updatePermission(params);
        this.getUsers();
      } catch (e) {
        this.$log.error(e);
      }
    }

    async togglePermission(record, enabled) {
      try {
        if (enabled) {
          this.enabledRecords.push(record.id);
        } else {
          this.enabledRecords = this.enabledRecords.filter(item => item != record.id);
        }
        const params = this.projectId ?
          { project_id: parseInt(this.projectId), user_ids: this.enabledRecords } :
          { user_id: parseInt(this.userId), project_ids: this.enabledRecords };

        await this.Project.updatePermission(params);

        if (this.projectId) {
          this.getUsers();
        }
      } catch (e) {
        this.checkIsAllEnabled();
        this.$log.error(e);
      }
    }

  }
};
